import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, shareReplay, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CodigoPostalOption {
  pk: number;
  descripcion: string;
}

@Injectable({
  providedIn: 'root'
})
export class CodigoPostalService {

  private baseUrl = `${environment.apiUrl}/api/codigos-postales`;
  private readonly cache = new Map<string, Observable<CodigoPostalOption[]>>();

  constructor(private http: HttpClient) { }

  // ================================================================
  // CÓDIGOS POSTALES (DEPARTAMENTO + MUNICIPIO + REFERENCIA)
  // ================================================================
  getCodigosPostales(
    fkDepartamento: number,
    fkMunicipio: number,
    referencia: string
  ): Observable<CodigoPostalOption[]> {
    const normalizedReference = referencia && referencia.trim() !== '' ? referencia.trim() : '0';
    const cacheKey = `${fkDepartamento}|${fkMunicipio}|${normalizedReference.toLowerCase()}`;

    const cached = this.cache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const params = new HttpParams()
      .set('departamento', fkDepartamento.toString())
      .set('municipio', fkMunicipio.toString())
      .set('referencia', normalizedReference);

    const request$ = this.http.get<CodigoPostalOption[]>(this.baseUrl, { params }).pipe(
      shareReplay({ bufferSize: 1, refCount: true }),
      catchError(error => {
        this.cache.delete(cacheKey);
        return throwError(() => error);
      })
    );

    this.cache.set(cacheKey, request$);
    return request$;
  }

}
